/**
 * Retries a dynamic import once after a short pause. Chunk fetches fail transiently on
 * flaky mobile links; a fetch failure is not cached by the module map, so retrying the
 * same specifier re-fetches it.
 */
export const retryImport = async <T>(
  load: () => Promise<T>,
  retries = 1,
  delayMs = 400
): Promise<T> => {
  try {
    return await load();
  } catch (error) {
    if (retries <= 0) throw error;
    await new Promise((resolve) => setTimeout(resolve, delayMs));
    return retryImport(load, retries - 1, delayMs * 2);
  }
};
